/** What the theme files set --viewport-background to, for a page that has not loaded them. */
const FALLBACK = { light: '#ffffff', dark: '#191c22' } as const;

/**
 * The background of every 3D view, the editor viewport and the comparison
 * views alike: the theme's --viewport-background, read from the document
 * as it is now themed.
 */
export function viewportBackground(): string {
  const root = document.documentElement;
  const value = getComputedStyle(root).getPropertyValue('--viewport-background').trim();
  if (value) return value;
  return root.getAttribute('data-theme') === 'dark' ? FALLBACK.dark : FALLBACK.light;
}
